// "Name · number" for a unit, without saying the same thing twice.
//
// Many units store a unitNumber that already contains the name
// ("WYNWOOD BY IMTIAZ/601", "RENA - Rena-2-201"), so name + number printed
// "Rena 2-201 · RENA - Rena-2-201". The number is only appended when its
// core digits (the last group of 3+, e.g. 505 in "Silena B-5-505") are not
// already in the name — or, for short numbers, when the text is not in it.
export function unitLabel(name?: string | null, unitNumber?: string | null): string {
  const n = String(name || '').trim();
  const u = String(unitNumber || '').trim();
  if (!u) return n;
  if (!n) return u;
  const low = (s: string) => s.toLowerCase().replace(/\s+/g, ' ');
  // One contains the other: the name is the label. (Returning the longer one
  // put an AI description like "…V-111, Unit 111, 5 Bedrooms, Plot Area…"
  // in place of the unit's name.)
  if (low(n).includes(low(u)) || low(u).includes(low(n))) return n;
  const digits = u.match(/\d{3,}/g);
  const core = digits ? digits[digits.length - 1] : '';
  if (core && n.includes(core)) return n;
  return `${n} · ${u}`;
}
